/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
import ko from 'knockout';
import pageContext from '@bingads-webui-static-legacy/page-context';
import filePickerTemplate from '@bingads-webui-static-legacy/uet/template/uploadConversions/filePicker.pug';
import FilePickerViewModel from '@bingads-webui-static-legacy/uet/viewmodel/uploadConversions/filePicker';
import TemplateFileUtil from '@bingads-webui-static-legacy/uet/view/uploadConversions/templateFileUtil';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import setting from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
var uploadFile = (function () {
  var file = _.first(_.first(this.$('.file-input')).files);
  this.trigger('fileSelected', file);
}).asLoggingStart(setting.ACTIVITYNAME.ClickOnUploadAndPreview);
var view = backbone.View.extend({
  events: {
    'click .btn-upload': uploadFile
  },
  initialize: function (options) {
    this.options = options || ({});
    this.options.isNewUI = this.options.isNewUI || false;
    const permissions = pageContext.Permissions;
    const {dynamic = {}} = permissions;
    const {OnlineConversionRestateRetractUI = false} = dynamic;
    this.options.OnlineConversionRestateRetractUI = OnlineConversionRestateRetractUI;
    this.ko_model = new FilePickerViewModel(this.options);
  },
  render: function () {
    var excelLink = '<a id="offlineImportTemplateXls" class="clickable" href="' + TemplateFileUtil.excelFileUrl + '">' + i18n.getString('UnifiedEventTracking_UploadConversions_Excel') + '</a>';
    var csvLink = '<a id="offlineImportTemplateCsv" class="clickable" href="' + TemplateFileUtil.csvFileUrl + '">' + i18n.getString('UnifiedEventTracking_UploadConversions_Csv') + '</a>';
    const permissions = pageContext.Permissions;
    const {dynamic = {}} = permissions;
    const {OnlineConversionRestateRetractUI = false} = dynamic;
    var html = filePickerTemplate({
      i18n: i18n,
      isNewUI: this.options.isNewUI,
      IsOfflineConversionRestateRetractFromUIAllowed: this.options.isNewUI && permissions.IsOfflineConversionRestateRetractFromUIAllowed,
      OnlineConversionRestateRetractUI: dynamic.OnlineConversionRestateRetractUI
    }).replace('{{fileTemplateExcel}}', excelLink).replace('{{fileTemplateCsv}}', csvLink);
    this.$el.html(html);
    if (this.$('.new-filepicker-tip').length > 0) {
      this.$('.new-filepicker-tip').empty().append(this.options.newFilePickerTip.render().$el);
    }
    ko.applyBindings(this.ko_model, this.el);
    instrumentation.endActivity();
    return this;
  },
  recoverBinding: function () {
    ko.cleanNode(this.el);
    this.undelegateEvents();
    this.delegateEvents();
    ko.applyBindings(this.ko_model, this.el);
    instrumentation.endActivity();
  }
});
export default view;

